// Published-setlist view: ordered tracklist → click → share player. Localized via i18n.
import type { SetlistMeta, SetlistItem } from '../setlist.js';
import { t } from './i18n.js';

interface SetlistViewOpts { setlist: SetlistMeta; items: SetlistItem[]; navigate: (path: string) => void; }

export function mountSetlistView(host: HTMLElement, opts: SetlistViewOpts): void {
  host.innerHTML = '';
  const root = document.createElement('div');
  root.className = 'setlist-view';

  const h = document.createElement('h1');
  h.textContent = opts.setlist.name;
  root.appendChild(h);

  if (opts.items.length === 0) {
    const empty = document.createElement('p');
    empty.dataset.role = 'empty';
    empty.textContent = t('setlist.empty');
    root.appendChild(empty);
    host.appendChild(root);
    return;
  }

  const sorted = [...opts.items].sort((a, b) => a.position - b.position);
  const list = document.createElement('ol');
  list.className = 'setlist-tracks';
  for (const it of sorted) {
    const row = document.createElement('button');
    row.dataset.role = 'track-row';
    row.dataset.shareId = it.shareId;
    row.className = 'setlist-track';
    row.textContent = t('setlist.trackRow', { pos: it.position + 1, name: it.songName ?? t('setlist.untitled') });
    row.addEventListener('click', () => opts.navigate('/' + it.shareId));
    const li = document.createElement('li');
    li.appendChild(row);
    list.appendChild(li);
  }
  root.appendChild(list);
  host.appendChild(root);
}
